export default {
    computed: {
        filteredLogs() {
            let logs = this.logs;
            let currentPath = this.$router.currentRoute.fullPath;
            let bid = this.$root.setting.business_id;

            // ensure list appears based on current business id (vet-1320)
            if (bid) {
                logs = logs.filter(item => item.business_id === bid);
            }

            if (logs.length > 0) {
                if (logs[0].url.includes(currentPath)) {
                    return logs.slice(1, 11);
                }
            }

            return logs.slice(0, 10);
        }
    },
    methods: {
        async getLogs() {
            let url = process.env.ACCOUNT_SERVICE + "recent-viewed-pages";
            let res = await this.$http.get(url);

            // collapse and expand items mobile view
            this.$emit("toggle-visibility");

            return res.data.response.resources;
        },
        capitalizeFirstLetter(word) {
            if (!word) return "";
            return word.charAt(0).toUpperCase() + word.slice(1);
        },
        checkUrl(url) {
            if (url) {
                if (url.charAt(0) === "/") {
                    return url.substring(1);
                }
            }
            return url;
        },
        goToPage(log) {
            if (
                log.module === "patient" &&
                !log.url.includes("index.php") &&
                !this.USE_PATIENT_MODULE_VUE
            ) {
                let patientEncodedId = log.url.split("/")[4];
                window.location.href = process.env.APPS + "patient/patient/view/" + patientEncodedId; // prettier-ignore
            } else if (
                log.module === "patient" &&
                log.url.includes("index.php") &&
                this.USE_PATIENT_MODULE_VUE
            ) {
                if (log.sub_module && log.sub_module == "lab") {
                    // this when lab view have enable
                    // let labId = log.reference_id.split(";")[1];
                    // this.$router.push({
                    //     name: "lab",
                    //     params: { id: labId }
                    // });
                    window.location.href =
                        process.env.APPS + this.checkUrl(log.url);
                } else {
                    let patientEncodedId = log.url.split("/")[5];
                    this.$router.push({
                        name: "patient_profile",
                        params: { id: patientEncodedId }
                    });
                }
            } else if (log.url.includes("../view")) {
                let newUrl = log.url.replace("../view", "");
                this.$router.push({ path: newUrl });
            } else if (
                log.module === "report" &&
                log.url.includes("index.php")
            ) {
                this.$router.push({
                    name: "report-ci",
                    params: { id: log.reference_id }
                });
            } else {
                window.location.href =
                    process.env.APPS + this.checkUrl(log.url);
            }
        }
    }
};
